exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "app-error>div{background-color:#c42720;border:1px solid #ab0700;color:#fff;box-shadow:0 1px 1px 0 rgba(0,0,0,.4)}app-error>div h2{margin:0}app-error>div pre{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/common/error/error.styl
// module id = 570
// module chunks = 0